export default __webpack_public_path__ + "windows-logo-silhouette.png";